import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260603_remove_prop_defs_table",
  description: "Remove propDefs table",
  apply(json) {
    delete json.propDefs;
    return json;
  },
};

export default migration;
